export const constToOption = <T extends string>(
  value: T,
  labels?: Partial<Record<T, string>>
) => ({ value, ...(labels && labels[value] ? { label: labels[value] } : {}) });
